import {
  useAreGeoFencesEnabled,
  useGeofencesAsideHttp,
  usePersistentObservatoryPageStore,
} from '@/feature/observatory'
import { useTelemetryCredentials } from '@/feature/telemetry/api/useMyTelemetryCredentials'

export const useObservatoryGeoFencesAside = () => {
  const { data: credentials } = useTelemetryCredentials()
  const geoFenceSearch = usePersistentObservatoryPageStore((state) => state.geoFenceSearch)
  const isGeoFenceEnabled = useAreGeoFencesEnabled()
  const isActive = isGeoFenceEnabled && credentials?.telemetryFleetName

  const queryParams = isActive
    ? {
        pageSize: Number.MAX_SAFE_INTEGER,
        search: geoFenceSearch,
        fleetName: credentials?.telemetryFleetName,
      }
    : null

  return useGeofencesAsideHttp(queryParams)
}
